/* 9R STUDIOS v5 — Premium JS
   Site loader, Permian-style staggered reveals, AJAX cart, variant selector */
(function(){
'use strict';

/* ═══ SITE LOADER (Permian/Casper-inspired) ═══ */
var loader = document.getElementById('site-loader');
var loaderBar = document.getElementById('loader-bar');
var loaderPct = document.getElementById('loader-pct');

(function(){
  if (!loader || document.documentElement.classList.contains('loader-seen')) {
    if (loader && loader.parentNode) loader.parentNode.removeChild(loader);
    return;
  }
  var progress = 0, done = false;
  function finish(){
    if (done) return; done = true;
    if (loaderBar) loaderBar.style.width = '100%';
    if (loaderPct) loaderPct.textContent = '100%';
    loader.classList.add('done');
    try { sessionStorage.setItem('9r_seen','1'); } catch(e){}
    setTimeout(function(){ if (loader.parentNode) loader.parentNode.removeChild(loader); }, 700);
  }
  var iv = setInterval(function(){
    progress = Math.min(progress + 12, 92);
    if (loaderBar) loaderBar.style.width = progress + '%';
    if (loaderPct) loaderPct.textContent = progress + '%';
  }, 80);
  // Harter Cap: max 1s Overlay — LCP/FCP bleiben unberührt, Content liegt darunter schon sichtbar
  setTimeout(function(){ clearInterval(iv); finish(); }, 1000);
  window.addEventListener('load', function(){ clearInterval(iv); finish(); });
})();

/* ═══ MOBILE MENU ═══ */
var toggle = document.getElementById('menu-toggle');
var menu = document.getElementById('mobile-menu');
if (toggle && menu) {
  toggle.addEventListener('click', function(e) {
    e.stopPropagation();
    var isOpen = menu.classList.contains('open');
    if (isOpen) {
      menu.classList.remove('open');
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    } else {
      menu.classList.add('open');
      toggle.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
  });
  // Close menu when clicking a link
  menu.querySelectorAll('a').forEach(function(link) {
    link.addEventListener('click', function() {
      menu.classList.remove('open');
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });
}

/* ═══ INTERSECTION OBSERVER REVEALS (Permian-style) ═══ */
function initReveals() {
  var sections = document.querySelectorAll('[data-reveal]');
  if (!sections.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('revealed');
        var children = e.target.querySelectorAll('[data-reveal-child]');
        children.forEach(function(child, i) {
          var d = parseInt(child.dataset.delay) || i;
          child.style.transitionDelay = (d * 0.1) + 's';
          // Use rAF for smoother paint
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              child.classList.add('revealed');
            });
          });
        });
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -60px 0px' });
  sections.forEach(function(s) { obs.observe(s); });
}
// Sofort booten (Script ist defer ⇒ DOM steht). NIE an window.load koppeln —
// große Medien (Hero-Video) verzögern load um Sekunden und lassen Sections leer wirken.
initReveals();
// Safety-Netz: was nach 3s nicht revealed ist (IO-Edge-Cases), wird hart sichtbar geschaltet.
setTimeout(function(){
  document.querySelectorAll('[data-reveal-child]:not(.revealed)').forEach(function(c){
    c.style.transitionDelay = '0s';
    c.classList.add('revealed');
  });
}, 3000);

/* ═══ GALLERY CAROUSEL ═══ */
var track = document.getElementById('gallery-track');
var prevBtn = document.getElementById('gallery-prev');
var nextBtn = document.getElementById('gallery-next');
if (track && prevBtn && nextBtn) {
  var slideW = function() {
    var s = track.querySelector('.gallery-slide');
    return s ? (s.offsetWidth + 20) : 400;
  };
  prevBtn.addEventListener('click', function() { track.scrollBy({ left: -slideW(), behavior: 'smooth' }); });
  nextBtn.addEventListener('click', function() { track.scrollBy({ left: slideW(), behavior: 'smooth' }); });
}

/* ═══ REVIEWS CAROUSEL ═══ */
var rTrack = document.getElementById('reviews-track');
var rPrev = document.getElementById('reviews-prev');
var rNext = document.getElementById('reviews-next');
if (rTrack && rPrev && rNext) {
  var rSlideW = function() { var s = rTrack.querySelector('.review-slide'); return s ? s.offsetWidth : 400; };
  rPrev.addEventListener('click', function() { rTrack.scrollBy({ left: -rSlideW(), behavior: 'smooth' }); });
  rNext.addEventListener('click', function() { rTrack.scrollBy({ left: rSlideW(), behavior: 'smooth' }); });
}

/* ═══ PRODUCT PAGE VARIANT SELECTOR ═══ */
var pdp = document.querySelector('.pdp:not(.pdp--homepage)');
if (pdp) {
  var pj = document.getElementById('product-json');
  var product = null;
  try { product = JSON.parse(pj.textContent); } catch(e) {}
  if (product) {
    var vs = document.getElementById('variant-select');
    var priceEl = document.getElementById('pdp-price');
    var atcBtn = pdp.querySelector('.atc-btn');
    var opts = {};
    product.options.forEach(function(o, i) {
      var g = pdp.querySelector('[data-option-index="' + i + '"]');
      if (g) { var s = g.querySelector('.selected'); if (s) opts[i] = s.dataset.value; }
    });
    pdp.querySelectorAll('.pdp-variant-options').forEach(function(g) {
      var idx = parseInt(g.dataset.optionIndex);
      g.querySelectorAll('.pdp-opt').forEach(function(b) {
        b.addEventListener('click', function() {
          g.querySelectorAll('.pdp-opt').forEach(function(x) { x.classList.remove('selected'); });
          b.classList.add('selected'); opts[idx] = b.dataset.value; uv();
        });
      });
    });
    pdp.querySelectorAll('.pdp-frame-options').forEach(function(g) {
      var idx = parseInt(g.dataset.optionIndex);
      g.querySelectorAll('.pdp-frame-opt').forEach(function(b) {
        b.addEventListener('click', function() {
          g.querySelectorAll('.pdp-frame-opt').forEach(function(x) { x.classList.remove('selected'); });
          b.classList.add('selected'); opts[idx] = b.dataset.value; uv();
          var asm = document.getElementById('assembly-options');
          if (asm) { var p = asm.closest('.pdp-variant-group'); if (p) p.style.display = b.classList.contains('no-frame') ? 'none' : ''; }
        });
      });
    });
    function uv() {
      var so = []; product.options.forEach(function(o, i) { if (opts[i]) so.push(opts[i]); });
      var m = null;
      for (var v = 0; v < product.variants.length; v++) {
        var vr = product.variants[v], ok = true;
        for (var o = 0; o < so.length; o++) { if (vr.options[o] !== so[o]) { ok = false; break; } }
        if (ok) { m = vr; break; }
      }
      if (m) {
        vs.value = m.id;
        if (priceEl) priceEl.textContent = fm(m.price);
        if (atcBtn) {
          if (m.available) { atcBtn.disabled = false; atcBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18"/><path d="M16 10a4 4 0 01-8 0"/></svg> Add to Cart'; }
          else { atcBtn.disabled = true; atcBtn.innerHTML = 'Sold Out'; }
        }
        var u = new URL(window.location); u.searchParams.set('variant', m.id); window.history.replaceState({}, '', u);
      }
    }
    var form = document.getElementById('product-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function(r) { return r.json(); })
          .then(function() { showToast('In den Warenkorb gelegt'); uc(); })
          .catch(function(err) { console.error(err); });
      });
    }
  }
  // Thumbnails
  pdp.querySelectorAll('.pdp-thumb').forEach(function(t) {
    t.addEventListener('click', function() {
      var idx = t.dataset.index;
      pdp.querySelectorAll('.pdp-thumb').forEach(function(x) { x.classList.remove('active'); });
      t.classList.add('active');
      pdp.querySelectorAll('.pdp-main-img').forEach(function(img) {
        img.classList.toggle('active', img.dataset.index === idx);
      });
    });
  });
  // Quantity
  var qi = pdp.querySelector('.qty-val');
  if (qi) {
    pdp.querySelectorAll('.qty-btn').forEach(function(b) {
      b.addEventListener('click', function() {
        var v = parseInt(qi.value) || 1;
        v += b.dataset.action === 'increase' ? 1 : -1;
        qi.value = Math.max(1, Math.min(20, v));
      });
    });
  }
}

/* ═══ QUICK ADD ═══ */
document.addEventListener('click', function(e) {
  var chip = e.target.closest('.quick-chip[data-variant-id]');
  if (!chip) return;
  e.preventDefault(); e.stopPropagation();
  chip.classList.add('adding');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(chip.dataset.variantId), quantity: 1 })
  })
    .then(function(r) { return r.json(); })
    .then(function() { showToast('In den Warenkorb gelegt'); uc(); chip.classList.remove('adding'); })
    .catch(function() { chip.classList.remove('adding'); });
});

/* ═══ CART COUNT ═══ */
function uc() {
  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
    document.querySelectorAll('.cart-count').forEach(function(el) {
      el.textContent = c.item_count;
      // Bounce animation
      el.style.transform = 'scale(1.3)';
      setTimeout(function() { el.style.transform = 'scale(1)'; }, 300);
    });
  });
}

/* ═══ CART PAGE QTY ═══ */
document.querySelectorAll('.qty-btn-sm').forEach(function(b) {
  b.addEventListener('click', function() {
    var l = b.dataset.line;
    var inp = document.querySelector('.qty-val-sm[data-line="' + l + '"]');
    if (!inp) return;
    var v = parseInt(inp.value) || 1;
    v += b.dataset.action === 'increase' ? 1 : -1;
    inp.value = Math.max(0, v);
    inp.closest('form').submit();
  });
});

/* ═══ SORT ═══ */
var ss = document.getElementById('sort-by');
if (ss) { ss.addEventListener('change', function() { var u = new URL(window.location); u.searchParams.set('sort_by', this.value); window.location = u; }); }

/* ═══ RECOVER ═══ */
if (window.location.hash === '#recover') { var r = document.getElementById('recover'); if (r) r.style.display = 'block'; }

function fm(c) { return '\u20AC' + (c / 100).toFixed(2).replace('.', ','); }
})();

/* ═══════════ 2026 SCALE LAYER ═══════════ */
(function(){
'use strict';
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ─── SCROLL VIDEO ─── */
document.querySelectorAll('[data-scroll-video]').forEach(function(sec){
  var frame = sec.querySelector('[data-sv-frame]');
  var media = sec.querySelector('video.sv-media');
  if(!frame) return;
  if(reduced){ frame.style.setProperty('--sv-p','1'); if(media) media.play().catch(function(){}); return; }
  var ticking = false;
  function update(){
    ticking = false;
    var r = sec.getBoundingClientRect(), vh = window.innerHeight;
    var total = r.height - vh; if(total <= 0) total = 1;
    var p = Math.min(1, Math.max(0, -r.top / (total * 0.6)));
    frame.style.setProperty('--sv-p', p.toFixed(3));
  }
  window.addEventListener('scroll', function(){ if(!ticking){ ticking = true; requestAnimationFrame(update); } }, { passive:true });
  update();
  if(media){
    new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ media.play().catch(function(){}); } else { media.pause(); } });
    }, { threshold: 0.2 }).observe(sec);
  }
});

/* ─── MASK REVEALS ─── */
var masks = document.querySelectorAll('[data-mask]');
if(masks.length && !reduced){
  var mo = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('unmasked'); mo.unobserve(e.target); } });
  }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });
  masks.forEach(function(m){ mo.observe(m); });
} else { masks.forEach(function(m){ m.classList.add('unmasked'); }); }

/* ─── MICRO PARALLAX ─── */
var pEls = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
if(pEls.length && !reduced){
  var pTick = false;
  function par(){
    pTick = false;
    var vh = window.innerHeight;
    var writes = [];
    for (var i = 0; i < pEls.length; i++) {           // Phase 1: nur READS
      var el = pEls[i], r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) continue;
      var f = parseFloat(el.dataset.parallax) || 0.05;
      writes.push([el, ((r.top + r.height/2 - vh/2) * -f).toFixed(1)]);
    }
    for (var j = 0; j < writes.length; j++) {          // Phase 2: nur WRITES
      writes[j][0].style.transform = 'translateY(' + writes[j][1] + 'px)';
    }
  }
  window.addEventListener('scroll', function(){ if(!pTick){ pTick = true; requestAnimationFrame(par); } }, { passive:true });
  par();
}

/* ─── STICKY ADD-TO-CART ─── */
var stickyBar = document.getElementById('sticky-atc');
var mainAtc = document.querySelector('.pdp:not(.pdp--homepage) .atc-btn');
var mainForm = document.getElementById('product-form');
if(stickyBar && mainAtc && mainForm){
  new IntersectionObserver(function(es){
    es.forEach(function(e){
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      stickyBar.classList.toggle('visible', show);
      stickyBar.setAttribute('aria-hidden', !show);
    });
  }, { threshold: 0 }).observe(mainAtc);
  var sPrice = document.getElementById('sticky-atc-price');
  var mPrice = document.getElementById('pdp-price');
  if(sPrice && mPrice){
    new MutationObserver(function(){ sPrice.textContent = mPrice.textContent; })
      .observe(mPrice, { childList:true, characterData:true, subtree:true });
  }
  var sBtn = document.getElementById('sticky-atc-btn');
  if(sBtn){
    sBtn.addEventListener('click', function(){
      if(typeof mainForm.requestSubmit === 'function'){ mainForm.requestSubmit(); }
      else { mainForm.dispatchEvent(new Event('submit', { cancelable:true, bubbles:true })); }
    });
  }
}

/* ─── E-MAIL POPUP ─── */
var pop = document.getElementById('epopup');
if(pop){
  var KEY = '9r_popup_until';
  var suppressDays = parseInt(pop.dataset.suppress) || 14;
  var delay = (parseInt(pop.dataset.delay) || 8) * 1000;
  var now = Date.now();
  var until = 0;
  try { until = parseInt(localStorage.getItem(KEY)) || 0; } catch(e){}
  var posted = /customer_posted=true/.test(location.search) || /challenge/.test(location.pathname);
  var suppressed = until > now;

  function suppress(days){
    try { localStorage.setItem(KEY, String(Date.now() + days*864e5)); } catch(e){}
  }
  function openPop(){
    if(pop.classList.contains('show')) return;
    pop.classList.add('show');
    pop.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  }
  function closePop(){
    pop.classList.remove('show');
    pop.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    suppress(suppressDays);
  }

  pop.querySelectorAll('[data-epopup-close]').forEach(function(el){ el.addEventListener('click', closePop); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && pop.classList.contains('show')) closePop(); });

  var form = document.getElementById('epopup-form');
  if(form){ form.addEventListener('submit', function(){ suppress(365); }); }

  if(/customer_posted=true/.test(location.search)){
    // Erfolgreich angemeldet → Danke-Zustand kurz zeigen
    var f = pop.querySelector('[data-epopup-state="form"]');
    var t = pop.querySelector('[data-epopup-state="thanks"]');
    if(f && t){ f.hidden = true; t.hidden = false; suppress(365); openPop(); }
  } else if(!suppressed && !posted){
    var timer = setTimeout(openPop, delay);
    // Exit-Intent nur Desktop
    if(matchMedia('(pointer:fine)').matches){
      document.addEventListener('mouseleave', function onLeave(e){
        if(e.clientY <= 0){ clearTimeout(timer); openPop(); document.removeEventListener('mouseleave', onLeave); }
      });
    }
  }
}
})();

/* ═══════════ INTERACTION LAYER ═══════════ */
(function(){
'use strict';
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var fine = window.matchMedia('(pointer:fine)').matches;

/* ─── DUO SHOWCASE: Cursor-Crossfade mit Dead-Zone ±50px, currentTime läuft immer weiter ─── */
document.querySelectorAll('[data-duo]').forEach(function(duo){
  var stage = duo.querySelector('[data-duo-stage]');
  var layers = { a: duo.querySelector('[data-duo-layer="a"]'), b: duo.querySelector('[data-duo-layer="b"]') };
  var labels = { a: duo.querySelector('.duo-label--a'), b: duo.querySelector('.duo-label--b') };
  var vids = duo.querySelectorAll('video.duo-media');
  if(!stage || !layers.a || !layers.b) return;
  var active = 'a';
  var DEAD = 50; // px Dead-Zone um die Mitte — kein abruptes Umschalten (prmpt-Spez)

  function setActive(k){
    if(k === active) return;
    active = k;
    layers.a.classList.toggle('is-active', k === 'a');
    layers.b.classList.toggle('is-active', k === 'b');
    if(labels.a) labels.a.classList.toggle('is-on', k === 'a');
    if(labels.b) labels.b.classList.toggle('is-on', k === 'b');
    // WICHTIG: currentTime NICHT resetten — beide Videos laufen synchron weiter
  }

  // Beide Videos nur im Viewport abspielen (beide parallel, damit Crossfade nahtlos ist)
  new IntersectionObserver(function(es){
    es.forEach(function(e){
      vids.forEach(function(v){ e.isIntersecting ? v.play().catch(function(){}) : v.pause(); });
    });
  }, { threshold: 0.25 }).observe(stage);

  if(fine && !reduced){
    stage.addEventListener('pointermove', function(e){
      var r = stage.getBoundingClientRect();
      var x = e.clientX - (r.left + r.width / 2);
      if(Math.abs(x) <= DEAD) return;          // Dead-Zone: letzter Zustand bleibt
      setActive(x < 0 ? 'a' : 'b');
    });
  } else {
    // Mobile/Reduced: sanfter Auto-Wechsel + Tap togglet
    if(!reduced){
      var t = setInterval(function(){
        var r = stage.getBoundingClientRect();
        if(r.top < window.innerHeight && r.bottom > 0) setActive(active === 'a' ? 'b' : 'a');
      }, 4000);
    }
    stage.addEventListener('click', function(e){
      if(e.target.closest('a')) return;
      setActive(active === 'a' ? 'b' : 'a');
    });
  }
});

/* ─── MAGNETIC BUTTONS (Desktop, subtil: max 6px Zug) ─── */
if(fine && !reduced){
  var mags = document.querySelectorAll('.btn-primary, .btn-secondary, .atc-btn, .epopup-btn');
  mags.forEach(function(btn){
    btn.setAttribute('data-magnetic','');
    var raf = null;
    btn.addEventListener('pointermove', function(e){
      if(raf) return;
      raf = requestAnimationFrame(function(){
        raf = null;
        var r = btn.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width/2)) / (r.width/2);
        var dy = (e.clientY - (r.top + r.height/2)) / (r.height/2);
        btn.style.transform = 'translate(' + (dx*6).toFixed(1) + 'px,' + (dy*4).toFixed(1) + 'px)';
      });
    });
    btn.addEventListener('pointerleave', function(){
      if(raf){ cancelAnimationFrame(raf); raf = null; }
      btn.style.transform = '';
    });
  });
}

/* ─── CURSOR DOT (Desktop, wächst über Interaktivem) ─── */
if(fine && !reduced){
  var dot = document.createElement('div');
  dot.className = 'cursor-dot';
  document.body.appendChild(dot);
  var dx2 = 0, dy2 = 0, cx = 0, cy = 0, shown = false;
  document.addEventListener('pointermove', function(e){
    dx2 = e.clientX; dy2 = e.clientY;
    if(!shown){ shown = true; dot.classList.add('on'); loop(); }
    var t = e.target;
    dot.classList.toggle('grow', !!(t.closest && t.closest('a, button, .product-card, .duo-stage')));
  }, { passive: true });
  function loop(){
    cx += (dx2 - cx) * 0.22; cy += (dy2 - cy) * 0.22;
    dot.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)';
    requestAnimationFrame(loop);
  }
  document.addEventListener('mouseleave', function(){ dot.classList.remove('on'); shown && (shown = false); });
}

/* ─── COUNT-UP (Hero-Stats: "20", "200g", "4") ─── */
var counters = document.querySelectorAll('[data-countup]');
if(counters.length){
  var co = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return;
      co.unobserve(e.target);
      var el = e.target, raw = el.textContent.trim();
      var m = raw.match(/^(\D*)(\d+)(.*)$/);
      if(!m){ return; }
      var prefix = m[1], target = parseInt(m[2],10), suffix = m[3];
      if(reduced || target <= 1){ return; }
      var start = null, DUR = 900;
      function step(ts){
        if(!start) start = ts;
        var p = Math.min(1, (ts - start) / DUR);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + Math.round(target * eased) + suffix;
        if(p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.6 });
  counters.forEach(function(c){ co.observe(c); });
}
})();

/* ─── PRODUCT STRIPS: Pfeil-Navigation ─── */
(function(){
document.querySelectorAll('.pstrip').forEach(function(strip){
  var track = strip.querySelector('[data-strip-track]');
  var prev = strip.querySelector('[data-strip-prev]');
  var next = strip.querySelector('[data-strip-next]');
  if(!track || !prev || !next) return;
  function step(){ var c = track.querySelector('.pstrip-card'); return c ? (c.offsetWidth + 14) * 2 : 400; }
  function sync(){
    prev.disabled = track.scrollLeft <= 4;
    next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
  }
  prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  next.addEventListener('click', function(){ track.scrollBy({ left:  step(), behavior: 'smooth' }); });
  track.addEventListener('scroll', function(){ requestAnimationFrame(sync); }, { passive: true });
  window.addEventListener('resize', sync);
  sync();
});
})();
